import * as Yup from 'yup'
import i18n, {FALLBACK_LANGUAGE} from "../i18n";
import {IUserSessionStore} from "../models/UserSessionStore";

export class LanguageService {
  private userSessionStore: IUserSessionStore;

  constructor(userSessionStore: IUserSessionStore) {
    this.userSessionStore = userSessionStore;
  }

  getPrimaryLanguage(): string {
    const contentLanguages = this.userSessionStore?.countryConfig?.contentLanguages || [];
    return contentLanguages.length > 0 ? contentLanguages[0] : FALLBACK_LANGUAGE;
  }

  getContentLanguages(): string[] {
    const contentLanguages = this.userSessionStore?.countryConfig?.contentLanguages || [];
    
    if (contentLanguages.length === 0) {
      return [FALLBACK_LANGUAGE];
    }
    
    return contentLanguages;
  }

  buildValidationSchemaForContentLanguages() {
    const primaryLanguage = this.getPrimaryLanguage();
    const languages = this.getContentLanguages();
    
    return Object.fromEntries(
      languages.map(langCode => [
        langCode,
        langCode === primaryLanguage ? Yup.string().required(i18n.t("fieldRequired")) : Yup.string(),
      ])
    );
  }

  buildDefaultsForContentLanguages() {
    const primaryLanguage = this.getPrimaryLanguage();
    const languages = this.getContentLanguages();
    
    return Object.fromEntries(
      languages.map(langCode => [
        langCode,
        langCode === primaryLanguage ? "" : undefined,
      ])
    );
  }

  // Form schema helpers
  createLocalizedTextSchema() {
    return Yup.object({
      text: Yup.object({
        ...this.buildValidationSchemaForContentLanguages()
      }),
    });
  }

  createLocalizedContentSchema() {
    return Yup.object({
      ...this.buildValidationSchemaForContentLanguages()
    });
  }

  // Form default value helpers
  createLocalizedTextDefaults() {
    return {
      text: {
        ...this.buildDefaultsForContentLanguages()
      }
    };
  }

  createLocalizedContentDefaults() {
    return {
      ...this.buildDefaultsForContentLanguages()
    };
  }
} 